var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99975 9.47509C7.28838 9.47509 6.60615 9.21239 6.10313 8.74478C5.60011 8.27717 5.31752 7.64295 5.31752 6.98165C5.31752 6.32034 5.60011 5.68613 6.10313 5.21851C6.60615 4.7509 7.28838 4.4882 7.99975 4.4882C8.71113 4.4882 9.39336 4.7509 9.89638 5.21851C10.3994 5.68613 10.682 6.32034 10.682 6.98165C10.682 7.30909 10.6126 7.63333 10.4778 7.93585C10.343 8.23836 10.1454 8.51324 9.89638 8.74478C9.64731 8.97631 9.35163 9.15998 9.0262 9.28529C8.70078 9.41059 8.35199 9.47509 7.99975 9.47509ZM7.99975 0C6.00791 0 4.09765 0.735564 2.6892 2.04488C1.28076 3.35419 0.489502 5.13 0.489502 6.98165C0.489502 12.2179 7.99975 19.9476 7.99975 19.9476C7.99975 19.9476 15.51 12.2179 15.51 6.98165C15.51 5.13 14.7188 3.35419 13.3103 2.04488C11.9019 0.735564 9.9916 0 7.99975 0Z",
    fill: "#58B310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreen);
export default __webpack_public_path__ + "static/media/location_green.3ae1b8760a0820ea6594ca1ab11b055b.svg";
export { ForwardRef as ReactComponent };